<div [ngStyle]="{color: color}"
  class="d-flex align-items-center justify-content-between">
  {{text}}
  @if (icon) {
    <mat-icon class="align-middle">{{icon}}</mat-icon>
  }
</div>
